var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoNitBlackContacto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 68,
    viewBox: "0 0 141 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.207031 68.0008V0.800781H12.495L44.079 47.7448V0.800781H56.367V68.0008H44.079L12.495 21.1528V68.0008H0.207031Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6445 68.0008V0.800781H80.9325V68.0008H68.6445Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.855 68.0008V11.2648H89.271V0.800781H140.823V11.2648H121.143V68.0008H108.855Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoNitBlackContacto);
export default __webpack_public_path__ + "static/media/icono_nit_black_contacto.9cf3958a57da359ecac8dd87c748df0c.svg";
export { ForwardRef as ReactComponent };